// extracted by mini-css-extract-plugin
export default {"container":"ScrollingText_container__nZ20P","text":"ScrollingText_text__Cobsa","animate":"ScrollingText_animate__DxDgY","scroll":"ScrollingText_scroll__yJE8d"};